export const NotificationIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
      <path
        d="M7.0029 18C8.01829 18 8.84906 17.1692 8.84906 16.1538H5.15675C5.15675 17.1692 5.97829 18 7.0029 18ZM12.5414 12.4615V7.84615C12.5414 5.01231 11.0275 2.64 8.38752 2.01231V1.38462C8.38752 0.618462 7.76906 0 7.0029 0C6.23675 0 5.61829 0.618462 5.61829 1.38462V2.01231C2.96906 2.64 1.46444 5.00308 1.46444 7.84615V12.4615L0.273671 13.6523C-0.307867 14.2338 0.0982865 15.2308 0.919825 15.2308H13.0767C13.8983 15.2308 14.3137 14.2338 13.7321 13.6523L12.5414 12.4615Z"
        fill="white" />
    </svg>
  )
}